import fuzzysort from "fuzzysort";
import {
  FEATURED_POI_CATEGORY_IDS,
  POI_CATEGORIES,
  type PoiCategory,
} from "./categories.ts";

interface CategoryCandidate {
  category: PoiCategory;
  searchableText: string;
}

const CANDIDATES = POI_CATEGORIES.map((category) => ({
  category,
  searchableText: [
    category.label,
    ...category.aliases,
  ].join(" "),
})) satisfies readonly CategoryCandidate[];

const CATEGORY_BY_ID = new Map(
  POI_CATEGORIES.map((category) => [category.id, category] as const),
);

export function featuredPoiCategories(): PoiCategory[] {
  return FEATURED_POI_CATEGORY_IDS.map((id) => {
    const category = CATEGORY_BY_ID.get(id);
    if (!category) {
      throw new RangeError(`Unknown featured POI category id: ${id}`);
    }
    return category;
  });
}

export function matchPoiCategories(query: string): PoiCategory[] {
  if (query.trim() === "") return [];

  return fuzzysort.go(query, CANDIDATES, {
    key: "searchableText",
  }).map((result) => result.obj.category);
}
